module.exports = __webpack_public_path__ + "static/Qmameri_blanc-cacb8c09c5b015dc5b15cd28f521d2de.png";